<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Hierarchy Groupings base on Organization Level</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
          <hierarchy-group
            :class-padding="classPadding"
            :title="'Hierarchy Group'"
            :label="'Hierarchy Group'"
            v-model="selectedGroup"
            :code-value="false"
          ></hierarchy-group>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
          <org-levels
            :class-padding="classPadding"
            :title="'Organizational Levels'"
            :label="'Organizational Level'"
            v-model="selectedOrgLevel"
            :code-value="false"
          ></org-levels>
        </v-col>
        <!-- <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Level"
            :class="classPadding"
            v-model="model.code"
            type="number"
            min="1"
            max="15"
          ></v-text-field>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            >Save</v-btn
          >
        </v-col>
      </v-row>
      <br/>
      <v-data-table 
        v-model="selected"
        :headers="headers" 
        :items="items" 
        item-key="id"
        show-select
        class="elevation-1">
        <template v-slot:top>
          <v-btn
            @click.stop="deleteItem"
            text
            icon
            class="pl-5"
            :loading="isDeleting"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import userAccessMixin from "../../../../../mixins/userAccessMixin";
import HierarchyGroup from "../hierarchy-group/Lookup.vue"
import OrgLevels from "@/views/others/org-level/OrgLevelLookup.vue"
const API_ENDPOINT = "/api/hierarchyGroup";
export default {
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    model: {},
    selectedGroup: {},
    selectedOrgLevel: {},
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Organizational Level",
        value: "orgLevelDesc",
        sortable: true
      },
      {
        text: "Level",
        value: "level",
        sortable: true
      }
    ],
    items: [],
    selected: [],
    isSaving: false,
    isDeleting: false
  }),
  components: {
    HierarchyGroup,
    OrgLevels
  },
  methods: {
    save() {
      this.isSaving = true;
      this.model.groupCode = this.selectedGroup.code;
      this.model.orgLevel = this.selectedOrgLevel.code;
      this.$axios.post(`${API_ENDPOINT}/gol`, this.model)
        .then(({ data }) => {
          this.$toast.success(data.message);

          this.getGroupOrgLeves(this.selectedGroup.code);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false
        })
    },
    getGroupOrgLeves(code) {
      this.$axios.get(`${API_ENDPOINT}/gol/${code}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    deleteItem() {
      this.isDeleting = true;
      this.$axios.post(`${API_ENDPOINT}/delete/gol`, this.selected)
        .then(({ data }) => {
          this.$toast.success(data.message);

          this.getGroupOrgLeves(this.selectedGroup.code);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isDeleting = false
        })
    },
    reset() {
      this.selectedOrgLevel = {}
    }
  },
  watch: {
    selectedGroup(val) {
      this.getGroupOrgLeves(val.code);
    },
    selected(val) {
      console.log(val)
    }
  },
  created() {
    this.getUserAccessRights("HierGOL");
  }
}
</script>